import React, { type ReactElement } from 'react'
import { Typography } from '@mui/material'
import ThemeButton, { BUTTON_VARIANTS } from 'common/ui/theme-button/ThemeButton'

import styles from './CrashScreen.module.scss'

const CrashScreen: React.FC = (): ReactElement => {
  return (
    <div className={styles.container}>
      <Typography variant="title6">Došlo je do neočekivane greške.</Typography>
      <ThemeButton
        variant={BUTTON_VARIANTS.outlined}
        onClick={() => {
          location.reload()
        }}
      >
        Ponovo učitajte stranicu
      </ThemeButton>
    </div>
  )
}

export default CrashScreen
